import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Spinner, Alert } from 'react-bootstrap';
import { version, buildDate } from '../version';
import { versionAPI } from '../api/versionAPI';

function AboutScreen() {
    const [backendVersion, setBackendVersion] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchBackendVersion();
    }, []);

    const fetchBackendVersion = async () => {
        console.log('DEBUG - Fetching backend version at:', new Date().toISOString());
        try {
            const data = await versionAPI.get();
            console.log('DEBUG - Received backend version data:', data);
            setBackendVersion(data);
        } catch (err) {
            setError('Failed to fetch backend version information');
            console.error('Error fetching backend version:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="py-3">
            <h1 className="mb-4">About</h1>
            <Card>
                <Card.Header>
                    <h5 className="mb-0">System Version Information</h5>
                </Card.Header>
                <Card.Body>
                    {error && (
                        <Alert variant="warning" className="mb-3">
                            {error}
                        </Alert>
                    )}
                    
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Component</th>
                                <th>Version</th>
                                <th>Build Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>Frontend</strong></td>
                                <td>{version}</td>
                                <td>{buildDate}</td>
                            </tr>
                            <tr>
                                <td><strong>Backend</strong></td>
                                <td>
                                    {loading ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : (
                                        backendVersion?.backend_version || 'Unknown'
                                    )}
                                </td>
                                <td>
                                    {loading ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : (
                                        backendVersion?.backend_build_date || 'Unknown'
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default AboutScreen;